//Contact.vue file

<template>
  <div class="contact">
    <!-- DEBUT BANNIERE -->

    <div class="ban"></div>
    <div class="container">
      <div class="page">
        <!-- DEBUT FIL D'ARIANE -->

        <nav aria-label="Breadcrumb" class="breadcrumb">
          <ul>
            <li>
              <router-link to="/">ACCUEIL</router-link>
            </li>
            <li class="bc-li">
              <span aria-current="page" class="current-page">CONTACT</span>
            </li>
          </ul>
        </nav>

        <!-- FIN FIL D'ARIANE -->

        <h1>Contactez-nous</h1>

        <div class="big_tel">
          <i class="fad fa-phone-alt tel_icon"></i>
          <label for=""><a href="tel:+33562677704">05 62 67 77 04</a></label>
        </div>
        

        <div class="_errors" v-if="errors.length">
          <ul>
            <li v-for="(error, index) in errors" :key="'error' + index">
              {{ error }}
            </li>
          </ul>
        </div>
        <div class="_success" v-if="success.length">
          <p>{{ success[0] }}</p>
        </div>
        <!-- <div class="content"> -->

        <!-- DEBUT DU FORMULAIRE -->

        <div class="formulaire">
          <div class="form">
            <div class="col-2">
              <div class="form-row-3">
                <h2>Contact</h2>
                <input
                  type="text"
                  name="company"
                  id="company"
                  placeholder="Société"
                  v-model="company"
                />
                <div class="bloc-flex">
                  <input
                    type="text"
                    name="lastname"
                    id="lastname"
                    placeholder="*Nom"
                    v-model="lastname"
                    required="required"
                  />
                  <input
                    type="text"
                    name="firstname"
                    id="firstname"
                    placeholder="*Prénom"
                    v-model="firstname"
                    required="required"
                  />
                </div>
              </div>
              <div class="form-row-3">
                <h2>Coordonnées</h2>
                <div class="bloc-flex">
                  <input
                    type="tel"
                    name="phone"
                    id="phone"
                    placeholder="*Téléphone"
                    v-model="phone"
                    required="required"
                  />
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="*E-mail"
                    v-model="email"
                    required="required"
                  />
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="form-row-3">
                <h2>Demande</h2>
                <select
                  name="subject"
                  v-model="subject"
                  id="subject"
                  required="required"
                >
                  <option value="Electricité générale"
                    selected>Electricité générale</option
                  >
                  <option value="Domotique">Domotique</option>
                  <option value="Panneaux photovoltaïques"
                    >Panneaux photovoltaïques</option
                  >
                  <option value="Pompe à chaleur">Pompe à chaleur</option>
                  <option value="Climatisation">Climatisation</option>
                  <option value="Autre">Autre</option>
                </select>
                <textarea
                  name="message"
                  id="message"
                  cols="30"
                  rows="4"
                  placeholder="*Message"
                  v-model="message"
                  required="required"
                ></textarea>
                <div class="checkbox">
                  <input
                    type="checkbox"
                    name="acceptInfosConditionUse"
                    id="acceptInfosConditionUse"
                    v-model="acceptInfosConditionUse"
                    @click="!acceptInfosConditionUse"
                    required="required"
                  />
                  <label for="acceptInfosConditionUse"
                    >*En cochant cette case, j'accepte que les informations
                    saisies soient exploitées dans le cadre d'une demande
                    d'information/devis.</label
                  >
                </div>
              </div>
              <button @click="coForm(); resetForm()">ENVOYER</button>
            </div>
          </div>
        </div>

        <!-- FIN DU FORMULAIRE -->

        <div class="coordonnees">

          <!-- DEBUT DES COORDONNEES -->

          <div class="adresse">
            <h3>Jean-Luc BOAS</h3>
            <div class="adress_txt">
              <i class="fad fa-map-marked-alt"></i>
              <label for="">ZA La Fourcade</label>
            </div>
            <div class="adress_txt">
              <i class="fad fa-mailbox"></i>
              <label for="">32200 GIMONT</label>
            </div>
            <div class="adress_txt">
              <i class="fad fa-globe-europe"></i>
              <label for="">Gers - France</label>
            </div>
            <div class="adress_txt">
              <i class="fad fa-phone-alt"></i>
              <label for=""><a href="tel:+33562677704">05 62 67 77 04</a></label>
            </div>
            <div class="adress_txt">
              <i class="fad fa-envelope"></i>
              <label for=""><a href="mailto:elec.boas@orange.fr">elec.boas@orange.fr</a></label>
            </div>
            <p></p>
            <p></p>
            <p></p>
            <p>
              
            </p>
          </div>

          <!-- FIN DES COORDONNEES -->

          <!-- DEBUT DE LA MAP -->

          <div id="map">
            <l-map :zoom="16" :center="[43.62064, 0.90728]">
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              ></l-tile-layer>
              <l-marker :lat-lng="[43.62064, 0.90728]"></l-marker>
            </l-map>
          </div>

          <!-- FIN DE LA MAP -->

          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { titleMixin } from "../mixins/titleMixin";

export default {
  metaInfo: {
    meta: [
      {
        vmid: "description",
        name: "description",
        content: "Contactez-nous pour toutes demandes concernant l'électricité générale, dans le domaine tertiaire et industriel, la domotique, les panneaux photovoltaïque ainsi que les systèmes de chauffage ou de climatisation. Entreprise BOAS à Gimont dans le Gers"
      },
      {
        vmid: "keywords",
        name: "keywords",
        content: "Contact, Électricité générale, Tertiaire, Industriel, Photovoltaïque, Domotique, Chauffage, Climatisation"
      }
    ]
  },
  name: "contact",
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  mixins: [titleMixin],
  data() {
    return {
      title: "Contactez-nous BOAS électricité Gimont Gers",
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

      siteID: 4,

      company: "",
      lastname: "",
      firstname: "",
      phone: "",
      email: "",
      street: "",
      city: "",
      zipcode: "",
      county: "",
      country: "",
      subject: "",
      message: "",
      acceptInfosCommercialUse: 0,
      acceptInfosConditionUse: 0,

      infosBrowser: "",
      infosIP: "",

      errors: [],
      success: []
    };
  },
  mounted() {
    this.getIPAdress();
  },
  methods: {
    resetForm() {
      document.getElementById("company").value = "";
      document.getElementById("lastname").value = "";
      document.getElementById("firstname").value = "";
      document.getElementById("phone").value = "";
      document.getElementById("email").value = "";
      document.getElementById("message").value = "";
    },
    validEmail(email) {
      var regEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regEmail.test(email);
    },
    validPhone(phone) {
      phone.trim();
      phone = phone.split(" ").join("");
      var regPhone = /^0[1-9][0-9]{8}$/;
      return regPhone.test(phone);
    },
    validText(text) {
      var regText = /[^0-9]*/;
      return regText.test(text);
    },
    validMessage(message) {
      var regMessage = /\b(?:(?!http)\w)+\b/;
      return regMessage.test(message);
    },
    coForm() {
      if (
        this.lastname &&
        this.validText(this.lastname) &&
        this.firstname &&
        this.validText(this.firstname) &&
        this.phone &&
        this.validPhone(this.phone) &&
        this.email &&
        this.validEmail(this.email) &&
        this.subject &&
        this.message &&
        this.validMessage(this.message) &&
        this.acceptInfosConditionUse
      ) {
        // let myApiKey = 'VrPndaEzxehPS7f63ZEr8vVdK2HtGDfD';  // API Key de test
        let myApiKey = "Q2D9B598uD87LecZJ22tSd3j2ZrPbggf";

        let myStr =
          this.company +
          "|" +
          this.lastname +
          "|" +
          this.firstname +
          "|" +
          this.phone +
          "|" +
          this.email +
          "|" +
          this.street +
          "|" +
          this.city +
          "|" +
          this.zipcode +
          "|" +
          this.county +
          "|" +
          this.country +
          "|" +
          this.subject +
          "|" +
          this.message +
          "|" +
          this.acceptInfosCommercialUse +
          "|" +
          this.acceptInfosConditionUse +
          "|" +
          this.infosBrowser +
          "|" +
          this.infosIP +
          "|" +
          this.siteID;
        // console.log(myStr);

        let success = this.success;

        this.company = "";
        this.lastname = "";
        this.firstname = "";
        this.phone = "";
        this.email= "";
        this.phone = "";
        this.subject = "",
        this.message = "";
        this.acceptInfosConditionUse = 0;

        this.errors = [];

        fetch(
          "https://ws-gbbu02.graphibox.eu/WebService.asmx/ToolsSymetricEncrypt",
          {
            method: "POST",
            mode: "cors",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify({
              pKey: myApiKey,
              pDatas: myStr
            })
          }
        )
          .then(function(r) {
            return r.json();
          })
          .then(function(r) {
            let data = JSON.parse(r.d);
            // console.log("success : ");
            // console.log(data);
            let myStrEncrypt = data.replace(/"/g, "");

            if (myStrEncrypt != "") {
              fetch(
                "https://ws-gbbu02.graphibox.eu/WebService.asmx/SendContact",
                {
                  method: "POST",
                  mode: "cors",
                  headers: {
                    "Content-Type": "application/json; charset=utf-8"
                  },
                  body: JSON.stringify({
                    pKey: myApiKey,
                    pType: "web-contact-BOAS",
                    pDatas: myStrEncrypt
                  })
                }
              )
                .then(function(res) {
                  return res.json();
                })
                .then(function() {
                  // console.log("res.d : ");
                  // console.log(res.d);
                  success.push("Votre demande à bien été envoyée.");
                });
            }
          });
                

      } else {
        this.errors = [];
        let errors = this.errors;

        if (this.lastname === "") {
          errors.push("Veuillez renseigner votre nom.");
        } else if (!this.validText(this.lastname)) {
          errors.push("Veuillez renseigner un nom valide.");
        }

        if (this.firstname === "") {
          errors.push("Veuillez renseigner votre prénom.");
        } else if (!this.validText(this.firstname)) {
          errors.push("Veuillez renseigner un prénom valide.");
        }

        if (this.phone === "") {
          errors.push("Veuillez renseigner votre n° de téléphone.");
        } else if (!this.validPhone(this.phone)) {
          errors.push("Veuillez renseigner un n° de téléphone valide.");
        }

        if (this.email === "") {
          errors.push("Veuillez renseigner votre email.");
        } else if (!this.validEmail(this.email)) {
          errors.push("Veuillez renseigner un email valide.");
        }

        if (this.subject === "") {
          errors.push("Veuillez renseigner le sujet de votre demande.");
        }

        if (this.message === "") {
          errors.push("Veuillez renseigner votre message.");
        } else if (!this.validMessage(this.message)) {
          errors.push("Veuillez ne pas mettre de liens dans votre message.");
        }
        if (this.acceptInfosConditionUse === 0) {
          errors.push("Veuillez accepter les conditions d'utilisations.");
        }

        // console.log(errors);
      }
    },
    getIPAdress() {
      fetch("https://ws-gbbu02.graphibox.eu/GetIp.aspx")
        .then(res => {
          return res.json();
        })
        .then(res => {
          this.infosIP = res.IP;
          this.infosBrowser = res.BROWSER;
          // console.log(this.infosIP);
          // console.log(this.infosBrowser);
        });
    }
  }
};
</script>

<style scoped>
/* MAP */
@import "~leaflet/dist/leaflet.css";

#map {
  margin-top: 5rem;
  width: 100%;
  height: 400px;
}

/* GENERAL */
.contact h1 {
  text-align: center;
  margin-top: 3%;
  font-family: Montserrat-SemiBold;
  font-size: 2.4rem;
  color: rgb(173, 17, 30);
}
.contact a {
  color: black;
}
.contact a:hover {
  color: rgb(173, 17, 30);
}
.big_tel {
  text-align: center;
  padding: 2%;
  margin-bottom: 1rem;
}
.big_tel .tel_icon,
.big_tel label {
  font-size: 1.8rem !important; 
}

/* FORMULAIRE */
.formulaire {
  width: 97.5%;
  background-color: rgba(0, 0, 0, 0.215);
  padding: 0 1rem;
  border-radius: 3px;
}
.form {
  display: flex;
  justify-content: space-between;
}
.form-row-3 {
  display: flex;
  flex-direction: column;
  margin: 3% 0;
}
input[type="text"],
input[type="tel"],
input[type="email"],
select,
textarea {
  padding: 1% 1%;
  border: 1px solid rgb(196, 180, 180);
  border-radius: 3px;
  margin-top: 2%;
  font-size: 1rem;
}
input:focus,
select:focus,
textarea:focus {
  outline: none !important;
  border-color: rgb(173, 17, 30);
  box-shadow: 0 0 10px rgba(173, 17, 30, 0.85);
}
.formulaire button {
  font-family: Montserrat-SemiBold;
  color: white;
  background-color: black;
  border: 1px solid black;
  border-radius: 3px;
  margin: 2rem 0 1.5rem 0;
  padding: 1rem;
  font-size: 1rem;
  cursor: pointer;
  float: right;
}
.formulaire button:hover {
  background-color: white;
  color: black;
}
.checkbox {
  display: flex;
  justify-content: flex-start;
  margin-top: 3%;
}
.checkbox label {
  font-size: .8rem;
}
.formulaire h2 {
  font-size: 1rem;
}

/* COORDONNEES */
.coordonnees {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

/* ADRESSE */
.adresse {
  margin-top: 8%;
  width: 30%;
}
.adresse h3 {
  font-size: 1.5rem;
}
.adresse p {
  font-size: 1.1rem;
}
.adress_txt {
  margin-bottom: 3%;
}
.fad {
  color: rgb(173, 17, 30);
  font-size: 1rem;
  margin-right: 3%;
}

/* VALIDATION DU FORMULAIRE */
._errors {
  background-color: #f5d2d2;
  padding: 1% 0;
  color: #470808;
  margin-bottom: 1rem;
  border-radius: 3px;
}

._success {
  position: fixed;
  top: 0;
  width: 50%;
  background-color: #daf5d2;
  padding: 1% 3%;
  color: #214708;
  z-index: -10;
  opacity: 0;
  animation-name: hide;
  animation-duration: 3s;
  border-radius: 3px;
}

.col-2 {
  width: 49%;
}
.bloc-flex {
  display: flex;
  justify-content: space-between;
}

.bloc-flex  input{
  width: 46%
}

@keyframes hide {
  0% {
    opacity: 1;
    z-index: 99;
  }
  65% {
    opacity: 0.9;
    z-index: 99;
  }
  100% {
    opacity: 0;
    z-index: -1;
  }
}

/* RESPONSIF */
@media all and (max-width: 1000px) {
  #map {
    width: 80%;
    height: 300px;
  }
}
@media all and (max-width: 760px) {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .formulaire {
    width: 90%;
  }
  .coordonnees {
    width: 100%;
  }
  .coordonnees,
  .form,
  .bloc-flex  {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .bloc-flex input {
    width: 97.3%;
  }
  .col-2 {
    width: 95%;
  }
  #map,
  .adresse{
    text-align: center;
    margin: 0;
    width: 100%;
  }
}
</style>
